// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"46793393","488":"7213179a","977":"2caed02d"}[chunkId] + ".chunk.js";
};